import { Injectable, Inject } from '@angular/core';
import { Observable } from 'rxjs';
import { HttpClient, HttpResponse } from '@angular/common/http';

@Injectable()
export class IndividualB2LinkService {
  constructor(
    protected http: HttpClient,
    @Inject('API_URL') private readonly apiUrl: string) {
  }

  public get(instance: string, beslutId: string): Observable<HttpResponse<ArrayBuffer>> {
    return this.http.get(`${this.apiUrl}${instance}/beslut/getIndividualB2/${beslutId}`, { responseType: 'arraybuffer', observe: 'response' });
  }
}
